export default {
    name: 'customer_register',
    component() {
        return {
            showCustomerAccountFormPopup: false,
            init() {
                window.addEventListener("toggle-display-open", (e) => {
                    if (e.detail.message === "header-signup") {
                        this.showCustomerAccountFormPopup = !this.showCustomerAccountFormPopup;
                    }
                });
            },
        }
    }
}